const triggerInvoca = (): void => {
    if (typeof window !== 'undefined') window.Invoca?.PNAPI.run();
};

export default triggerInvoca;
